import _ from "lodash";
import React from "react";
import classes from "./UnitDetails.scss";
import ResourceImagePlaceHolder from "UIComponents/ResourceImagePlaceHolder";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { UnitPlanOutlined } from "@toddle-edu/ds-icons";
import { getAttachmentUrlFromFieldValue } from "Utils";
import { isMultipleUnitTaggingEnabled } from "Post/utils";

const BLANK_OBJECT = {};
const UnitDetailComponent = ({
  t,
  headerText,
  item,
  subDetailContainerStyle,
  subDetailRightContainerStyle,
  detailTextStyle,
  showDesignV2,
  unitItem,
  resourceImagePlaceHolderStyle,
  showHeaderText,
  userType,
  useDSV2,
}) => {
  const imageUrl = getAttachmentUrlFromFieldValue({
    fieldValue: _.get(item, "image", ""),
  });
  const isLeTagged = _.isEqual(_.get(item, "assessmentType.value"), "le");
  const isMutipleUnitTagging = isMultipleUnitTaggingEnabled();

  const detailsSubHeaderText = classNames({
    [classes.detailSubHeaderText]: true,
    ["text-label-l"]: !useDSV2,
    ["text-label"]: useDSV2,
  });

  const detailTextClasses = classNames({
    [classes.detailText]: true,
    ["text-body"]: true,
  });

  return (
    <div
      className={classes.subDetailContainer}
      style={subDetailContainerStyle ?? BLANK_OBJECT}
    >
      <div
        className={classes.subDetailLeftContainer}
        data-test-id="journal-feed-leunitcontainer"
      >
        <div className={detailsSubHeaderText}>
          {!item
            ? t("common:no_associated_lable", {
                element: _.lowerCase(headerText),
              })
            : _.size(_.get(item, "title.value"))
            ? _.get(item, "title.value")
            : "Untitled"}
        </div>
        {showDesignV2 ? (
          <div
            className={detailTextClasses}
            style={detailTextStyle ?? BLANK_OBJECT}
          >
            {isLeTagged ? (
              <>
                <span>LE</span>
                {unitItem ? <div className={classes.leDot}></div> : null}
              </>
            ) : (isMutipleUnitTagging && showHeaderText) ||
              !isMutipleUnitTagging ? (
              headerText
            ) : null}
            {isLeTagged ? _.get(unitItem, "title.value", "") : null}
          </div>
        ) : (
          <div
            className={detailTextClasses}
            style={detailTextStyle ?? BLANK_OBJECT}
          >
            {headerText}
          </div>
        )}
      </div>
      {item && (
        <div
          className={classes.subDetailRightContainer}
          style={subDetailRightContainerStyle ?? BLANK_OBJECT}
        >
          <ResourceImagePlaceHolder
            id={item.id}
            imageUrl={imageUrl || _.get(item, "image.value", "")}
            type={item.assessmentType}
            containerStyle={resourceImagePlaceHolderStyle}
          />
        </div>
      )}
    </div>
  );
};

const UnitDetails = ({
  unitPlan,
  resourceItem,
  showIcon,
  subDetailContainerStyle,
  subDetailRightContainerStyle,
  detailTextStyle,
  detailInnerContainerStyle,
  iconContainerStyle,
  iconVariant,
  showResourceItem = true,
  showUnitPlan = true,
  detailContainerStyle,
  showDesignV2,
  showDetailsHeaderText = true,
  resourceImagePlaceHolderStyle,
  userType = "staff",
  canAddWorksheetResponseToPost,
  useDSV2 = false,
}) => {
  const { t } = useTranslation(["common"]);

  const detailTextClasses = classNames({
    [classes.detailText]: true,
    ["text-body"]: true,
  });

  return (
    <div
      className={classes.detailContainer}
      style={detailContainerStyle ?? BLANK_OBJECT}
    >
      <div
        className={classes.detailInnerContainer}
        style={detailInnerContainerStyle}
      >
        {showIcon && (
          <div
            className={classes.iconContainer}
            style={{ ...(iconContainerStyle ?? {}) }}
          >
            <UnitPlanOutlined
              size={"xx-small"}
              variant={iconVariant ?? "default"}
            />
          </div>
        )}
        {showDetailsHeaderText ? (
          <div className={classes.detailsHeaderText}>{t("common:unit")}</div>
        ) : null}
      </div>
      {unitPlan || resourceItem || canAddWorksheetResponseToPost ? (
        <div className={classes.detailDataContainer}>
          {showUnitPlan ? (
            <UnitDetailComponent
              t={t}
              headerText={t("common:unit")}
              item={unitPlan}
              subDetailContainerStyle={subDetailContainerStyle}
              subDetailRightContainerStyle={subDetailRightContainerStyle}
              detailTextStyle={detailTextStyle}
              showDesignV2={showDesignV2}
              resourceImagePlaceHolderStyle={resourceImagePlaceHolderStyle}
              showHeaderText={!unitPlan}
              userType={userType}
              useDSV2={useDSV2}
            />
          ) : null}
          {showResourceItem && resourceItem && (
            <UnitDetailComponent
              t={t}
              headerText={
                canAddWorksheetResponseToPost
                  ? t("common:worksheet")
                  : t("common:le_label")
              }
              item={resourceItem}
              subDetailContainerStyle={subDetailContainerStyle}
              showDesignV2={showDesignV2}
              unitItem={unitPlan}
              resourceImagePlaceHolderStyle={resourceImagePlaceHolderStyle}
              subDetailRightContainerStyle={
                showDesignV2 ? subDetailRightContainerStyle : null
              }
              showHeaderText={true}
              userType={userType}
              useDSV2={useDSV2}
            />
          )}
        </div>
      ) : (
        <div className={classes.subDetailContainer}>
          <div className={detailTextClasses}>
            {t("no_unit_details_associated")}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitDetails;
